export default "__VITE_ASSET__31c71ab1__"